<template>
    <div>
        <!--DOCUMENT : this loads a document editor in an iframe. Upone save, the iframe passes the info to a hidden input field. There are many piece option settings for this piece.-->
        <label class="control-label">{{ pieceName }}</label>
        <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>

        <p class="designer-description">To make changes, click the highlighted text or graphics. When everything looks good to you, click the Approve button.</p>
        <div class="'step designer" :class="{'designer-iframe-wrapper': !iframeLoaded, ['designer-' + stepId]: true}">
            <iframe
                    :id="'design' + pieceId"
                    :src="iframeUrl"
                    allowtransparency="true"
                    frameborder="0"
                    allowfullscreen
                    @load="iframeLoaded = true"
            >
            </iframe>
        </div>
        <b>* Be sure to click the <span class="document-notice-yellow">Yellow</span> Approve Button to save your image</b>

        <div v-if="typeof pieceOptions !== 'undefined' && typeof pieceOptions.document_type !== 'undefined'">
            <input v-if="pieceOptions.document_type === 'pdf'" :id="'design' + pieceId + 'content'" class="pdf" type="hidden" :name="'pieces[' + pieceIndex + '][content]'" :value="contentValue">
        </div>

        <input :id="'design' + pieceId + 'sessionkey'" type="hidden" :name="'pieces[' + pieceIndex + '][data][session_key]'" :value="sessionKeyValue">
        <div class="step-spacer"></div>
    </div>
</template>

<script>

    import utils from "../../../../mixins/utils";

    export default {
        name: 'document-piece',
        mixins: [utils],
        data() {
            return {
                contentValue: '',
                iframeLoaded: false,
                sessionKeyValue: ''
            }
        },
        props: {
            stepId: {
                type:Number,
                required:true
            },
            pieceId: {
                type:Number,
                required:true
            },
            pieceIndex: {
                type: Number,
                required:true
            },
            pieceName: {
                type: String,
                required:true
            },
            pieceOrder: {
                type: Number,
                required:true
            },
            pieceContent: {
                type: String,
                required:true
            },
            pieceData: {
                type: Object,
                required:true
            },
            pieceOptions: {
                type: Object,
                required:true
            },
        },
        computed: {
            iframeUrl() {
              return '/inventory/designer/?&q=&begin&pid=' + this.pieceId + '&pieceIndex=' + this.pieceOrder + '&ps-product=' + this.pieceOptions.ps_product + '&ps-template=' + this.pieceOptions.ps_template + '&psheet-id=' + this.pieceOptions.psheet_id + '&session-key=' + this.storedSessionKey;
            },
            storedSessionKey() {
                const sessionKey = this.pieceData?.session_key || this.pieceOptions?.session_key || '';
                return sessionKey !== 'undefined' ? sessionKey : '';
            }
        },
        watch: {
            pieceContent: {
                immediate: true,
                handler(content) {
                    this.contentValue = this.escapeHtml(this.stripSlashes(content));
                }
            },
            storedSessionKey: {
                immediate: true,
                handler(value) {
                    this.sessionKeyValue = value;
                }
            },
        },
        methods: {
            disableSavingForm(disabled) {
                this.$emit('disable-saving', {disabled, pieceId: this.pieceId, message: 'You need to approve all documents'});
            },
            onMessage(event) {
                if (!event.data || typeof event.data !== 'string') {
                    return;
                }

                const message = JSON.parse(event.data);
                if (this.pieceId === Number(message.pid)) {
                    if (!message.editing) {
                        this.sessionKeyValue = message.sessionKey;
                        this.contentValue = message.url;
                    }
                    this.disableSavingForm(Boolean(message.editing));
                }
            }
        },
        mounted() {
            this.disableSavingForm(true);
            window.addEventListener('message', event => this.onMessage(event));
        }
    }
</script>

<style lang="scss">
    .designer-iframe-wrapper {
        background: rgb(51, 51, 51) url('https://s3.amazonaws.com/snappykraken/assets/website/img/document-loading.png') center center;
        background-repeat: no-repeat;
        background-size: 20%;
    }
</style>

